import type { Template } from "@/types";

export const LA_07_H2_V5: Template[] = [
    {
        id: "la-07-h2v5-01",
        name: "LA 01 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 99, y: 83, width: 232, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 99, y: 246, width: 232, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 338, y: 83, width: 239, height: 318, rotation: 0, imageRotation: 0 },
            { id: "4", x: 869, y: 245, width: 141, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 869, y: 40, width: 141, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 245, width: 141, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 40, width: 141, height: 198, rotation: 0, imageRotation: 0 }         
        ],
    },

    {
        id: "la-07-h2v5-02",
        name: "LA 02 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 62, y: 57, width: 289, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 245, width: 289, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 57, width: 256, height: 368, rotation: 0, imageRotation: 0 },
            { id: "4", x: 821, y: 58, width: 280, height: 368, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1109, y: 58, width: 94, height: 118, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1109, y: 183, width: 94, height: 118, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1109, y: 308, width: 94, height: 118, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-03",
        name: "LA 03 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 133, y: 45, width: 310, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 246, width: 310, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 45, width: 94, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 451, y: 179, width: 94, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 451, y: 312, width: 94, height: 127, rotation: 0, imageRotation: 0 },
            { id: "6", x: 822, y: 107, width: 190, height: 269, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 107, width: 189, height: 269, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-04",
        name: "LA 04 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 133, y: 45, width: 94, height: 127, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 179, width: 94, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 133, y: 312, width: 94, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 235, y: 45, width: 310, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 235, y: 246, width: 310, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 769, y: 70, width: 242, height: 343, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 70, width: 241, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-05",
        name: "LA 05 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 47, y: 148, width: 284, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 148, width: 284, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 148, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 148, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 903, y: 148, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 148, width: 128, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1176, y: 148, width: 128, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-06",
        name: "LA 06 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 389, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 746, y: 74, width: 264, height: 165, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1018, y: 74, width: 265, height: 165, rotation: 0, imageRotation: 0 },
            { id: "4", x: 746, y: 246, width: 129, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 246, width: 128, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 246, width: 129, height: 164, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1155, y: 246, width: 128, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-07",
        name: "LA 07 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 783, y: 36, width: 462, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 783, y: 324, width: 87, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 878, y: 324, width: 87, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 972, y: 324, width: 86, height: 122, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1065, y: 324, width: 86, height: 122, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1159, y: 324, width: 86, height: 122, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-08",
        name: "LA 08 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 249, y: 53, width: 132, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 249, y: 246, width: 132, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 388, y: 53, width: 132, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 388, y: 246, width: 132, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 528, y: 53, width: 306, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 528, y: 246, width: 306, height: 184, rotation: 0, imageRotation: 0 },
            { id: "7", x: 842, y: 53, width: 260, height: 377, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-09",
        name: "LA 09 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 87, width: 210, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 218, y: 87, width: 210, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 87, width: 476, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 87, width: 210, height: 308, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1137, y: 87, width: 217, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 236, width: 104, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1248, y: 236, width: 104, height: 159, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h2v5-10",
        name: "LA 10 - H2V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h2_v5_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 87, width: 476, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 484, y: 87, width: 210, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 701, y: 87, width: 210, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 87, width: 210, height: 308, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1137, y: 87, width: 217, height: 142, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 236, width: 104, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1248, y: 236, width: 104, height: 159, rotation: 0, imageRotation: 0 }
        ],
    }
];